// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.instructions-frame[data-v-e3b9d638] {
  display: flex;
  height: 100%;
  width: 100%;
  color: var(--text-contrast-color);
}
.container[data-v-e3b9d638] {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 1.5rem;
  padding: 2rem;
  margin: auto;
  max-width: 29rem;
}
.instructions-header[data-v-e3b9d638] {
  color: var(--header-contrast-color);
}
.instructions-header[data-v-e3b9d638],
.instructions-description[data-v-e3b9d638],
.sub-item-header[data-v-e3b9d638] {
  text-align: center;
}
.instructions-description[data-v-e3b9d638],
.sub-item-header[data-v-e3b9d638] {
  margin: 0;
}
.main-item[data-v-e3b9d638] {
  width: 100%;
  display: block;
}
.sub-item-header[data-v-e3b9d638] {
  grid-column: 1 / span 3;
}
.sub-item-image[data-v-e3b9d638] {
  display: block;
}
.sub-item-image > svg[data-v-e3b9d638] {
  border: 1px solid var(--dark);
}
.sub-item-description[data-v-e3b9d638] {
  text-align: center;
  line-height: 1.25;
}
.sub-item-description > img[data-v-e3b9d638] {
  height: 0.75rem;
}
.sub-item-description > span[data-v-e3b9d638] {
  vertical-align: text-bottom;
}
@media screen and (orientation: portrait) {
.container[data-v-e3b9d638] {
    max-height: 100%;
}
.suggestion[data-v-e3b9d638] {
    display: contents;
}
.sub-item-list[data-v-e3b9d638] {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto auto auto;
    grid-gap: 0.5rem 1rem;
    width: 100%;
}
.sub-item-image[data-v-e3b9d638] {
    grid-row-start: 2;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    width: 100%;
}
.sub-item-description[data-v-e3b9d638] {
    grid-row-start: 3;
    margin: 0;
}
}
@media screen and (orientation: landscape) {
.instructions-frame[data-v-e3b9d638] {
    overflow-y: auto;
}
.suggestion[data-v-e3b9d638] {
    display: flex;
    align-items: center;
    width: 100%;
    column-gap: 3rem;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}
.sub-item-header[data-v-e3b9d638] {
    white-space: nowrap;
    margin-bottom: 0.5rem;
}
.sub-item-list[data-v-e3b9d638] {
    display: flex;
    flex-direction: column;
}
.sub-item-image[data-v-e3b9d638] {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 3.5rem;
}
.sub-item-description[data-v-e3b9d638] {
    margin-top: 0.5rem;
    margin-bottom: 1.5rem;
}
.sub-item-description[data-v-e3b9d638]:last-child {
    margin-bottom: 0;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/partials/InstructionsFrame.vue"],"names":[],"mappings":";AAgEA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,iCAAA;AACA;AAEA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AACA;AAEA;EACA,mCAAA;AACA;AAEA;;;EAGA,kBAAA;AACA;AAEA;;EAEA,SAAA;AACA;AAEA;EACA,WAAA;EACA,cAAA;AACA;AAEA;EACA,uBAAA;AACA;AAEA;EACA,cAAA;AACA;AAEA;EACA,6BAAA;AACA;AAEA;EACA,kBAAA;EACA,iBAAA;AACA;AAEA;EACA,eAAA;AACA;AAEA;EACA,2BAAA;AACA;AAEA;AACA;IACA,gBAAA;AACA;AAEA;IACA,iBAAA;AACA;AAEA;IACA,aAAA;IACA,kCAAA;IACA,kCAAA;IACA,qBAAA;IACA,WAAA;AACA;AAEA;IACA,iBAAA;IACA,oBAAA;IACA,qBAAA;IACA,WAAA;AACA;AAEA;IACA,iBAAA;IACA,SAAA;AACA;AACA;AAEA;AACA;IACA,gBAAA;AACA;AAEA;IACA,aAAA;IACA,mBAAA;IACA,WAAA;IACA,gBAAA;IACA,kBAAA;IACA,qBAAA;AACA;AAEA;IACA,mBAAA;IACA,qBAAA;AACA;AAEA;IACA,aAAA;IACA,sBAAA;AACA;AAEA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;IACA,iBAAA;AACA;AAEA;IACA,kBAAA;IACA,qBAAA;AACA;AAEA;IACA,gBAAA;AACA;AACA","sourcesContent":["<template>\n  <div class=\"instructions-frame\">\n    <div class=\"container\">\n      <h1 v-if=\"header\" class=\"instructions-header\">\n        {{ header }}\n      </h1>\n      <p v-if=\"description\" class=\"instructions-description\">\n        <view-generator :data=\"description\" />\n      </p>\n      <div class=\"suggestion\">\n        <component :is=\"mainItem\" v-if=\"mainItem\" class=\"main-item\" />\n        <div v-if=\"subItems && subItems.length\" class=\"sub-item-list\">\n          <p v-if=\"subItemsHeader\" class=\"sub-item-header\">\n            {{ subItemsHeader }}\n          </p>\n          <template v-for=\"(item, index) in subItems\">\n            <div :key=\"index\" class=\"sub-item-image\">\n              <component :is=\"item.image\" />\n            </div>\n            <p :key=\"item.label\" class=\"sub-item-description\">\n              <img src=\"/public/images/close-icon.png\" />\n              <span class=\"sub-item-text\">{{ item.label }}</span>\n            </p>\n          </template>\n        </div>\n      </div>\n      <ui-button\n        slot=\"main\"\n        :label=\"action\"\n        class=\"button-style\"\n        photo-icon\n        @click=\"$emit('onaction')\"\n      />\n      <slot v-if=\"hasChildren\" />\n    </div>\n  </div>\n</template>\n\n<script>\nimport ViewGenerator from '@src/components/partials/ViewGenerator'\n\nexport default {\n  components: {\n    ViewGenerator\n  },\n\n  props: {\n    header: { type: String, default: null },\n    description: { type: [String, Array], default: null },\n    mainItem: { type: Object, default: null },\n    subItemsHeader: { type: String, default: null },\n    subItems: { type: Array, default: null },\n    action: { type: String, default: null }\n  },\n\n  computed: {\n    hasChildren() {\n      return !!this.$slots.default\n    }\n  }\n}\n</script>\n\n<style scoped>\n.instructions-frame {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  color: var(--text-contrast-color);\n}\n\n.container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  row-gap: 1.5rem;\n  padding: 2rem;\n  margin: auto;\n  max-width: 29rem;\n}\n\n.instructions-header {\n  color: var(--header-contrast-color);\n}\n\n.instructions-header,\n.instructions-description,\n.sub-item-header {\n  text-align: center;\n}\n\n.instructions-description,\n.sub-item-header {\n  margin: 0;\n}\n\n.main-item {\n  width: 100%;\n  display: block;\n}\n\n.sub-item-header {\n  grid-column: 1 / span 3;\n}\n\n.sub-item-image {\n  display: block;\n}\n\n.sub-item-image > svg {\n  border: 1px solid var(--dark);\n}\n\n.sub-item-description {\n  text-align: center;\n  line-height: 1.25;\n}\n\n.sub-item-description > img {\n  height: 0.75rem;\n}\n\n.sub-item-description > span {\n  vertical-align: text-bottom;\n}\n\n@media screen and (orientation: portrait) {\n  .container {\n    max-height: 100%;\n  }\n\n  .suggestion {\n    display: contents;\n  }\n\n  .sub-item-list {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    grid-template-rows: auto auto auto;\n    grid-gap: 0.5rem 1rem;\n    width: 100%;\n  }\n\n  .sub-item-image {\n    grid-row-start: 2;\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n    width: 100%;\n  }\n\n  .sub-item-description {\n    grid-row-start: 3;\n    margin: 0;\n  }\n}\n\n@media screen and (orientation: landscape) {\n  .instructions-frame {\n    overflow-y: auto;\n  }\n\n  .suggestion {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    column-gap: 3rem;\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .sub-item-header {\n    white-space: nowrap;\n    margin-bottom: 0.5rem;\n  }\n\n  .sub-item-list {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .sub-item-image {\n    margin-left: auto;\n    margin-right: auto;\n    width: 100%;\n    max-width: 3.5rem;\n  }\n\n  .sub-item-description {\n    margin-top: 0.5rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .sub-item-description:last-child {\n    margin-bottom: 0;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
